import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import { Client } from '@stomp/stompjs';
import { addMessage } from '@Store/slices/notificationsSlice';
// import { extractAuthToken } from '@Utils/api/extractAuthToken';
// import { RootState } from '@Store/store';
import { getApiUrl } from '@Utils/getApiUrl';

interface WebSocketState {
  client: Client | null;
  connected: boolean;
}

const baseUrl = getApiUrl();
const domainURL = baseUrl?.split('//');

const initialState: WebSocketState = {
  client: null,
  connected: false,
};

export const notificationsApi = createSlice({
  name: 'notificationsApi',
  initialState,
  reducers: {
    setClient: (state, action: PayloadAction<Client>) => {
      state.client = action.payload;
    },
    setConnected: (state, action: PayloadAction<boolean>) => {
      state.connected = action.payload;
    },
    deactivateClient: (state) => {
      state.client?.deactivate();
    },
  },
});

export const notificationsWebSocket =
  (tokenParam: string) => (dispatch: Dispatch) => {
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';

    const domain = domainURL?.length > 1 ? domainURL[1] : 'api.dev.tcgbms.com';

    const stompClientAPIGateway = new Client({
      brokerURL: `${protocol}://${domain}/ws/notification/stomp-websocket-endpoint?access_token=${tokenParam}`,
      reconnectDelay: 5000,
    });

    stompClientAPIGateway.onConnect = () => {
      dispatch(setConnected(true));
      stompClientAPIGateway.subscribe(
        '/user/topic/notifications',
        (message) => {
          const parsed = JSON.parse(message.body);

          dispatch(addMessage(parsed));
        }
      );
    };

    stompClientAPIGateway.activate();

    dispatch(setClient(stompClientAPIGateway));
  };

export const { setClient, setConnected, deactivateClient } =
  notificationsApi.actions;
